const m = require("air-vue-model")();
m.url = "ticket_messages";
m.name = "ticketMessage";

module.exports = m;
